module.exports = __webpack_public_path__ + "static/img/duom09.1650e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom09.png
// module id = 985
// module chunks = 0